module.exports = __webpack_public_path__ + "static/media/icon-communicationstyle.966fe260.svg";